import type { NDateLocale } from './enUS'
import { sr } from 'date-fns/locale'

const dateSrRS: NDateLocale = {
  name: 'sr-RS',
  locale: sr
}

export default dateSrRS
